import { type FC } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { Card } from "@jti/core-components/components/Card";
import { useSelector } from "@jti/store/reduxHooks";
import { selectOrder } from "@jti/store/selectors/selectOrder";
import { useTranslations } from "@jti/ui";

import { DeliveryFormShippingOptionMethodLabel } from "@checkout/forms/DeliveryForm/components/DeliveryFormShippingOptionMethodLabel";

import styles from "./DeliveryDetailsSection.module.scss";

export const DeliveryDetailsSection: FC = () => {
  const { __ } = useTranslations();
  const { showPricesWithTaxExcluded = false } = useConfig();

  const selectedOrder = useSelector((state) => selectOrder(state, showPricesWithTaxExcluded));
  const selectedTrialOrder = useSelector((store) => store.freeTrialCart.order.orderDetails.data);

  return (
    <div className={styles.viewMode}>
      <Card title={__("cart.checkout.shipping_option.title")} variant="level-1" data-testid="delivery-view-module">
        <DeliveryFormShippingOptionMethodLabel
          methodTitle={selectedOrder?.shippingMethod?.methodCode || selectedTrialOrder?.shippingMethod?.methodCode}
          amount={selectedOrder?.total?.total_shipping || selectedTrialOrder?.total?.total_shipping}
        />
      </Card>
    </div>
  );
};
